export default "tac6gx6" as string;

require("./theme.linaria.module.css!=!../../../../node_modules/.pnpm/@wyw-in-js+webpack-loader@0.6.0_webpack@5.99.5/node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./theme.ts");